import { validateURLDirect } from './formsUtilities';
const accessProvisions = [
    { name: "AccessibleBabyFacilities", label: `Cyfleusterau Hygyrch i Fabanod` },
    { name: "AccessibleParking", label: `Parcio Hygyrch` },
    { name: "AccessibleToilets", label: `Toiledau Hygyrch` },
    { name: "AdaptedInformation", label: `Gwybodaeth wedi\u2019i Haddasu` },
    { name: "AssistanceAnimals", label: `Anifeiliaid Cymorth` },
    { name: "AudioDescription", label: `Disgrifiadau Sain` },
    { name: "Captioning", label: `Capsiynau` },
    { name: "ChangingPlacesToilet", label: `Toiledau Changing Places` },
    { name: "ChilledPerformance", label: `Perfformiadau anffurfiol` },
    { name: "DementiaFriendly", label: `Dangosiadau sy\u2019n Deall Dementia ` },
    { name: "HearingLoopsAndHeadsets", label: `Dolenni Sain a Chlustffonau` },
    { name: "MinimalWalkingDistances", label: `Dim Llawer o Gerdded` },
    //{name:"NoContentWarnings",label:msg(`No Content Warnings`)},
    { name: "NoStrobeLightingHazeEffects", label: `Dim Effeithiau Niwl / Goleuadau Str\u00F4b` },
    { name: "QuietSpaces", label: `Mannau Tawel` },
    { name: "RelaxedPerformance", label: `Perfformiad Hamddenol` },
    { name: "SeatAccess", label: `Mynediad at y Seddi` },
    { name: "SensoryAdapted", label: `Wedi Addasu ar gyfer y Synhwyrau` },
    { name: "SignLanguage", label: `Iaith Arwyddion` },
    { name: "StepFreeLevelAccess", label: `Mynediad Heb Risiau` },
    { name: "WheelchairAccessible", label: `Mynediad i Gadeiriau Olwyn` },
];
const eventTypes = [
    { name: "ArtAndExhibitions", label: `Celf ac Arddangosfeydd` },
    { name: "Cabaret", label: `Cabaret` },
    { name: "Circus", label: `Syrcas` },
    { name: "Comedy", label: `Comedi` },
    { name: "CoursesAndWorkshops", label: `Cyrsiau a Gweithdai` },
    { name: "Craft", label: `Crefftau` },
    { name: "Dance", label: `Dawns` },
    { name: "FamiliarisationTours", label: `Teithiau Ymgyfarwyddo` },
    { name: "FamilyFriendly", label: `Ystyriol o Deuluoedd` },
    { name: "FilmCinema", label: `Ffilmiau/Sinema` },
    { name: "Festival", label: `G\u0175yl` },
    { name: "ImmersiveAndVR", label: `Ymdrochol a realiti rhithwir` },
    { name: "LiteratureAndPoetry", label: `Llenyddiaeth a Barddoniaeth` },
    { name: "Music", label: `Cerddoriaeth` },
    { name: "Musical", label: `Cerddoriaeth` },
    { name: "Opera", label: `Opera` },
    { name: "Pantomime", label: `Pantomeim` },
    { name: "TalksAndDebates", label: `Sgyrsiau a Dadleuon` },
    { name: "Theatre", label: `Theatr` },
    { name: "TouchTours", label: `Teithiau Cyffwrdd` }
];
const languages = [
    { name: 'en', label: 'English' },
    { name: 'cy', label: 'Cymraeg' },
    // {name: 'ga', label: 'Gaeilge'},
    { name: 'gd', label: 'Gaelic' }
];
const processEventData = (_eventData, locations = [], allProvisions = []) => {
    let returnEventData;
    let eventData = _eventData?.hasOwnProperty('event_data') ? _eventData.event_data : _eventData;
    let instances = [];
    if (eventData?.hasOwnProperty('instances')) {
        instances = eventData.instances.map(instance => {
            let date = instance.start ? new Date(instance.start) : null;
            let endDate = instance.end ? new Date(instance.end) : null;
            // BEGINNING of new conditional to allow ceratin start date and end date scenarios
            const now = new Date(); // take back by seven days
            now.setDate(now.getDate() - 7);
            now.setHours(0, 0, 0, 0); // strip time
            const dateInPast = date ? new Date(date).setHours(0, 0, 0, 0) < now : false;
            const endDateInPast = endDate ? new Date(endDate).setHours(0, 0, 0, 0) < now : false;
            let allowOldDates = false;
            if (endDateInPast || (!endDate && dateInPast)) {
                return {}; //deal with empy object when rendered in allin-repeater
            }
            if (dateInPast) {
                allowOldDates = true;
            }
            // END of new conditional to allow ceratin start date and end date scenarios
            //---------------Prevent event instance start and end times from converting multiple times and adding more hours upon edit ------------------
            //let start_time = date ? date.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' }) : '';
            let start_time = instance.start ? instance.start.split('T')[1]?.substring(0, 5) : '';
            //let end_time = endDate ? endDate.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' }) : '';
            let end_time = instance.end ? instance.end.split('T')[1]?.substring(0, 5) : '';
            let start = date ? date.toISOString().split('T')[0] : '';
            let end = endDate ? endDate.toISOString().split('T')[0] : '';
            let bookingLink = instance.bookingLink ? instance.bookingLink : '';
            if (bookingLink) {
                bookingLink = validateURLDirect(bookingLink);
            }
            return {
                start: start,
                start_time: start_time,
                end: end,
                end_time: end_time,
                bookingLink: bookingLink,
                zoneId: instance.zone ? instance.zone.id : '',
                instance_id: instance.id,
                provisions: instance.provisions,
                allowOldDates: allowOldDates,
            };
        });
    }
    let formatValue = eventData?.format;
    // if(!formatValue){
    //     formatValue = 'InPerson'
    // }
    let isTouring = eventData?.location?.id && !locations.find(location => location.id === eventData?.location?.id);
    let locationIDValue = isTouring ? 'touring_location' : eventData?.location?.id;
    let touringLocationValue = isTouring ? eventData?.location?.id : null;
    if (!formatValue && !isTouring) {
        formatValue = 'InPerson';
    }
    if (isTouring && formatValue === "InPerson") {
        formatValue = 'Touring';
    }
    let locURL = eventData?.locationUrl ? validateURLDirect(eventData.locationUrl) : '';
    let eventURL = eventData?.eventUrl ? validateURLDirect(eventData.eventUrl) : '';
    returnEventData = [
        { name: 'name', type: 'text', title: `Beth yw enw eich digwyddiad?`, value: eventData?.name, 'required': true, description: ``, error_message: `Rhowch enw eich digwyddiad` },
        { name: 'language', type: 'select', title: `Ym mha iaith fyddwch chi\u2019n cyflwyno\u2019r digwyddiad hwn?`, value: eventData?.language || 'en', options: languages, description: `Gallwch greu mwy nag un digwyddiad mewn ieithoedd gwahanol a fydd yn ymddangos ar dudalennau\u2019r rhestrau wedi\u2019u cyfieithu.`, error_message: `Dewiswch brif iaith eich digwyddiad` },
        { name: 'locationId', type: 'select', title: `Ym mha leoliad y cynhelir y digwyddiad hwn?`, value: locationIDValue, 'required': true, options: locations?.map(location => ({ label: location.name, value: location.id })), description: `Dywedwch wrth gynulleidfaoedd ble bydd y digwyddiad hwn yn cael ei gynnal drwy ddewis o\u2019r lleoliadau rydych chi wedi\u2019u creu.`, error_message: `Dewiswch leoliad eich digwyddiad` },
        { name: 'locationUrl', type: 'url', title: `Ychwanegwch ddolen i\u2019r dudalen gwybodaeth am fynediad ar gyfer eich digwyddiad`, value: locURL, description: `Dolen i wybodaeth berthnasol am fynediad` },
        { name: 'locationName', type: 'text', title: `Ychwanegwch enw ar gyfer eich lleoliad teithio`, value: eventData?.locationName, description: `Enw ar gyfer eich lleoliad teithio` },
        { name: 'touringLocation', type: 'locationsearch', title: `Lleoliad teithio`, value: touringLocationValue, requiredif: 'touring_location' },
        { name: 'type', type: 'multiselect', title: `Pa fath o ddigwyddiad yw hwn?`, value: eventData?.type, 'required': true, options: eventTypes, error_message: `Dewiswch yr opsiwn agosaf o\u2019r rhestr o fathau o ddigwyddiadau` },
        { name: 'format', type: 'select', title: `Beth yw fformat eich digwyddiad?`, value: formatValue, options: [
                { value: 'InPerson', label: 'In Person' },
                { value: 'Online', label: 'Online' },
                { value: 'Hybrid', label: 'Hybrid' },
                { value: 'Touring', label: 'On Tour' },
            ], description: `Dewiswch opsiwn i nodi a yw\u2019r digwyddiad hwn yn cael ei gynnal wyneb yn wyneb, ar-lein, neu a yw\u2019n ddigwyddiad hybrid y gellir ei brofi ar-lein neu wyneb yn wyneb.` },
        { name: 'photo1', type: 'file', title: `Lleoliad`, value: eventData?.photo1 },
        { name: 'photo2', type: 'file', title: `Lleoliad`, value: eventData?.photo2 },
        { name: 'photo3', type: 'file', title: `Lleoliad`, value: eventData?.photo3 },
        { name: 'multiloader', type: 'multiloader', description: `Gallwch lanlwytho delweddau i ymddangos ar restr eich digwyddiad.` },
        { name: 'description', type: 'textarea', title: `Ychwanegwch ddisgrifiad byr am y digwyddiad hwn.`, value: eventData?.description, 'required': true, description: `Dylai hwn fod yn drosolwg byr o lai na 500 nod.`, error_message: `Ychwanegwch ddisgrifiad o\u2019r digwyddiad` },
        { name: 'priceRangeLow', type: 'number', title: `Ystod prisiau: isel`, value: eventData?.priceRangeLow, min: 0.01, step: 1, description: `Rhowch bris y tocyn rhataf ar gyfer y digwyddiad hwn, i roi syniad i gwsmeriaid o\u2019r ystod prisiau.` },
        { name: 'priceRangeHigh', type: 'number', title: `Ystod prisiau: uchel`, value: eventData?.priceRangeHigh, min: 0.01, step: 1, description: `Rhowch bris y tocyn drutaf ar gyfer y digwyddiad hwn, i roi syniad i gwsmeriaid o\u2019r ystod prisiau.` },
        { name: 'defaultBookingLink', type: 'url', title: `Ychwanegwch y ddolen archebu gyffredinol`, value: eventURL, description: `Rhowch gyfeiriad gwe eich tudalen archebu gyffredinol er mwyn i gynulleidfaoedd gael rhagor o wybodaeth a phrynu tocynnau ar gyfer eich digwyddiad.` },
        { name: 'instances', type: 'repeater', title: `Enghreifftiau o ddigwyddiadau`, value: instances, subFields: [
                { name: 'start', type: 'date', title: `Dyddiad dechrau`, value: '', required: true, error_message: `Rhowch ddyddiad cychwyn` },
                { name: 'start_time', type: 'time', title: `Amser cychwyn`, value: '', required: true, error_message: `Ychwanegwch amser cychwyn` },
                { name: 'end', type: 'date', title: `Dyddiad gorffen`, value: '', required: false, showif: 'start' },
                { name: 'end_time', type: 'time', title: `Amser gorffen`, value: '', showif: 'start', requiredif: 'end' },
                { name: 'bookingLink', type: 'url', title: `Dolen archebu`, value: '', description: `Rhowch gyfeiriad gwe eich tudalen archebu ar gyfer eich digwyddiad er mwyn i gynulleidfaoedd gael rhagor o wybodaeth a phrynu tocynnau.` },
                { name: 'zoneId', type: 'select', title: `Ym mha barth mae hyn?`, value: '', description: `Dywedwch wrth gynulleidfaoedd ble bydd y digwyddiad hwn yn cael ei gynnal drwy ddewis y parth.`, error_message: `Dewiswch barth` },
                { name: 'provisions', type: 'provisions', title: `Pa ddarpariaethau mynediad sydd ar gael ar gyfer y digwyddiad hwn?`, provisions: allProvisions },
                { name: 'instance_id', type: 'hidden', title: '', value: '' }
            ], description: `Yma, byddwch yn mewnbynnu gwybodaeth fel dyddiad ac amser eich digwyddiad a\u2019r darpariaethau mynediad sydd ar gael. Os yw\u2019r digwyddiad hwn yn cael ei gynnal ar sawl dyddiad/amser, gallwch ychwanegu\u2019r enghreifftiau hyn yn unigol.` },
        { name: 'status', 'type': 'select', 'title': `Statws`, 'value': eventData?.status || 'Draft', 'required': true, 'options': [{ label: `Drafft`, value: 'Draft' }, { label: `Cyhoeddwyd`, value: 'Published' }], description: `Os ydych chi\u2019n barod i gyhoeddi eich digwyddiad er mwyn i gynulleidfaoedd gael rhagor o wybodaeth, newidiwch y statws o \u2018drafft\u2019 i \u2018cyhoeddwyd\u2019 a phwyso \u2018cyflwyno\u2019.` },
    ];
    return returnEventData;
};
const processProvisionData = (provisionData) => {
    provisionData = Object.entries(provisionData);
    provisionData = provisionData?.map((provision) => {
        provision = provision[1];
        provision.provisions = provision.provisions.map((item) => {
            if (item.hasOwnProperty('provision_data')) {
                return {
                    name: item.standard?.name,
                    id: item.standard?.id,
                    image: item.provision_data.photo?.publicUrl,
                    alt: item.provision_data.photo?.altText,
                    description: item.provision_data?.description,
                    draft: item.provision_data?.draft,
                };
            }
            else {
                return {
                    name: item.name,
                    id: item.id,
                    image: item.image,
                    alt: item.alt,
                    description: item.description,
                    draft: item.draft,
                };
            }
        });
        return provision;
    });
    return provisionData;
};
const formatDateString = (date, longFormat = false, includeTime = true) => {
    if (!date)
        return '';
    let dateObj = new Date(date);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    if (longFormat) {
        let year = '';
        let minutes = '';
        let hours = dateObj.getUTCHours();
        let ampm = 'am';
        if (hours >= 12) {
            ampm = 'pm';
        }
        hours = hours % 12;
        hours = hours ? hours : 12;
        if (new Date().getUTCFullYear() !== dateObj.getUTCFullYear()) {
            year = ` ${dateObj.getUTCFullYear()}`;
        }
        let timestr = '';
        if (includeTime) {
            if (dateObj.getUTCMinutes() !== 0) {
                minutes = `:${dateObj.getUTCMinutes().toString().padStart(2, '0')}`;
            }
            timestr = hours + minutes + ampm;
        }
        return [`${days[dateObj.getUTCDay()]}, ${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]}${year}`, timestr];
    }
    if (!includeTime) {
        return `${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]} ${dateObj.getUTCFullYear()}`;
    }
    return `${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]} ${dateObj.getUTCFullYear()}, ${dateObj.getUTCHours().toString()}:${dateObj.getUTCMinutes().toString().padStart(2, '0')}`;
};
const dateToMaybeRange = (open, close, longFormat = true) => {
    //console.log({open, close, longFormat});
    const parseDate = (dateStr) => {
        return new Date(dateStr);
    };
    // Helper function to format date according to the specified format
    const formatDate = (date, format) => {
        const options = {
            weekday: format.includes('D') ? 'short' : undefined,
            day: format.includes('j') ? 'numeric' : (format.includes('d') ? '2-digit' : undefined),
            month: format.includes('F') ? 'long' : (format.includes('m') ? '2-digit' : undefined),
            year: format.includes('Y') ? 'numeric' : undefined
        };
        // Remove undefined properties
        Object.keys(options).forEach(key => options[key] === undefined && delete options[key]);
        if (format === 'd') {
            return date.getUTCDate().toString().padStart(2, '0');
        }
        if (format === 'd/m') {
            return `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`;
        }
        if (format === 'm/Y') {
            return `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
        }
        if (format === 'Y') {
            return date.getUTCFullYear().toString();
        }
        if (format === 'm') {
            return (date.getUTCMonth() + 1).toString().padStart(2, '0');
        }
        if (format === 'd/m/Y') {
            return `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
        }
        if (format === 'j') {
            return `${date.getUTCDate()}`;
        }
        if (format === 'j F') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
        }
        if (format === 'F Y') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return `${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
        }
        if (format === 'F') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return months[date.getUTCMonth()];
        }
        if (format === 'j F Y') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
        }
        return date.toLocaleDateString();
    };
    // Define format strings based on longFormat parameter
    let day, dayMonth, monthYear, year, month, dayMonthYear;
    if (longFormat) {
        day = "j";
        dayMonth = "j F";
        monthYear = "F Y";
        year = "Y";
        month = "F";
        dayMonthYear = "j F Y";
    }
    else {
        day = "d";
        dayMonth = "d/m";
        monthYear = "m/Y";
        year = "Y";
        month = "m";
        dayMonthYear = "d/m/Y";
    }
    // If no close date or dates are the same, return single date
    let closeNoTime = close ? close.split('T')[0] : null;
    let openNoTime = open ? open.split('T')[0] : null;
    if (!close || openNoTime === closeNoTime) {
        return formatDate(parseDate(open), dayMonthYear);
    }
    const openDate = parseDate(open);
    const closeDate = parseDate(close);
    const eventStartMonth = openDate.getMonth();
    const eventEndMonth = closeDate.getMonth();
    const eventStartYear = openDate.getFullYear();
    const eventEndYear = closeDate.getFullYear();
    // Same month and year - show day range
    if (eventStartMonth === eventEndMonth && eventStartYear === eventEndYear) {
        return formatDate(openDate, day) + " - " + formatDate(closeDate, dayMonthYear);
    }
    // Same year - show month range
    else if (eventStartYear === eventEndYear) {
        return formatDate(openDate, dayMonth) + " - " + formatDate(closeDate, dayMonthYear);
    }
    // Different years - show full date range
    else {
        return formatDate(openDate, dayMonthYear) + " - " + formatDate(closeDate, dayMonthYear);
    }
};
const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: 'stripIfInteger'
});
export { eventTypes, processEventData, processProvisionData, formatDateString, dateToMaybeRange, currencyFormatter };
